import { blue } from '@mui/material/colors'
import { deepmerge } from '@mui/utils'
import { createTheme } from '@mui/material/styles'

const baseTheme = createTheme({
  palette: {
    primary: {
      light: blue[100],
      main: blue[500]
    },
    secondary: {
      light: blue[200],
      main: blue[800]
    },
    customColors: {
      title: '#FFFFFF',
      error: '#f83333'
    },
    backgroundColors: {
      selected: '#ffffdd',
      selectedHover: '#fdfdc6',
      hover: '#e5f3ff'
    },
    title: {
      main: blue[400]
    },

    seat: {
      available: '#b6ffb9',
      selected: '#ffd67d',
      occupied: '#fd7269'
    }
  },
  typography: {
    h1: {
      fontSize: '2.0rem',
      '@media (min-width:600px)': {
        fontSize: '4rem'
      }
    },
    h3: {
      fontSize: '2.0rem',
      '@media (min-width:600px)': {
        fontSize: '3.0rem'
      }
    },
    h4: {
      fontSize: '1.5rem',
      '@media (min-width:600px)': {
        fontSize: '2.5rem'
      }
    },
    h6: {
      fontSize: '0.80rem',
      '@media (min-width:600px)': {
        fontSize: '1.00rem'
      },
      color: '#617df8'
    },
    body2: {
      fontSize: '0.70rem',
      '@media (min-width:600px)': {
        fontSize: '1.00rem'
      }
    }
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: blue[500],
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
            color: blue[800]
          }
        }
      }
    }
  }
})

export const baseDarkTheme = createTheme(
  deepmerge(baseTheme, {
    palette: {
      mode: 'dark',

      background: {
        default: '#121212', // Custom background color
        paper: '#1d1d1d' // Custom paper background color
      },
      text: {
        primary: '#ffffff', // Default text color (e.g., white)
        secondary: '#c0f3ff' // Secondary text color
      },

      title: {
        main: blue[100]
      },
      action: {
        active: '#3c94b3' // Default color for icons
      },
      backgroundColors: {
        selected: '#42423e',
        selectedHover: '#65655b',
        hover: '#4d9de1'
      },
      seat: {
        available: '#62ff65',
        selected: '#ffd67d',
        occupied: '#c84649'
      }
    },
    typography: {
      h6: {
        color: '#617df8'
      }
    },

    components: {
      MuiTabs: {
        styleOverrides: {
          indicator: {
            backgroundColor: blue[500] // Customize the color of the selected tab's indicator (underline)
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            color: '#fff', // Default color of the tab labels
            '&.Mui-selected': {
              color: blue[500] // Color of the selected tab
            },
            '&:hover': {
              color: blue[300] // Color of the tab label on hover
            }
          }
        }
      }
    }
  })
)

export const theme = baseTheme
export const darkTheme = baseDarkTheme
